export default __webpack_public_path__ + "static/extravagant-versaille-cfb1d855a7ac307f57e6f9aaaa4699f5.jpg";